export default {
  sucursalSeleccionada: (state) => state.sucursalSeleccionada,
  haySucursalSeleccionada: (state) => !!state.sucursalSeleccionada,
}